import React from "react";

function getMarker(marker, index) {
    if (marker === "check") {
        return "✓";
    }

    return String(index + 1).padStart(2, "0");
}

function getHeadingComponent(headingLevel) {
    return headingLevel === 3 ? "h3" : "h4";
}

export default function PlatformNewsFeatureGrid({
    items,
    marker = "number",
    variant = "",
    headingLevel = 4,
}) {
    if (!items || items.length === 0) {
        return null;
    }

    const Heading = getHeadingComponent(headingLevel);

    const className = `platform-news-article__feature-grid${
        variant
            ? ` platform-news-article__feature-grid--${variant}`
            : ""
    }`;

    return (
        <div className={className}>
            {items.map((item, index) => (
                <div
                    className="platform-news-article__feature"
                    key={item.title}
                >
                    <span className="platform-news-article__feature-mark">
                        {getMarker(marker, index)}
                    </span>

                    <div>
                        <Heading>{item.title}</Heading>
                        <p>{item.text}</p>
                    </div>
                </div>
            ))}
        </div>
    );
}
